import '../App.css';
import { LimelIcon } from "../limel";
import { LimelCallout } from "../limel";

interface ValidationResult {
    domainVerificationValidationResult: DeliverabilitySettingValidationResult;
    dkimValidationResult: DeliverabilitySettingValidationResult;
    dmarcValidationResult: DeliverabilitySettingValidationResult;
    customReturnPathValidationResult: DeliverabilitySettingValidationResult;
    dkimIntructions: string;
    domainVerificationIntructions: string;
    customReturnPathIntructions: string;
    dmarcIntructions: string;
}

interface DeliverabilitySettingValidationResult {
    isValid: boolean;
    errorMessage: string;
    foundValues: string[];
    deliverabilitySettingErrorType: number;
}

export function DisplayValidationResult({ validationResult, domain, showReturnPathResult }: { validationResult: ValidationResult | null, domain: string; showReturnPathResult: boolean }) {

    return (
        <div className="app-results">
            {validationResult ?
                <div>
                    <h1>Results for {domain}</h1>
                    {getCallout("Domain Ownership Verification", "Invalid", validationResult.domainVerificationValidationResult)}
                    <br></br>
                    {getCallout("DKIM Verification", "Not found", validationResult.dkimValidationResult)}
                    <br></br>
                    {getCallout("DMARC Verification", "Not found", validationResult.dmarcValidationResult)}
                    <br></br>
                    {showReturnPathResult &&
                        <div>
                            {getCallout("Custom Return-path Verification", "Not found", validationResult.customReturnPathValidationResult)}
                            <br></br>
                        </div>
                    }
                    <div>
                        <i style={{ fontSize: "12px" }}>Note that the results are based on the current DNS settings for the domain. If you have made changes to the DNS settings, please wait for the changes to propagate before checking the results again.</i>
                    </div>
                    {validationResult.domainVerificationValidationResult.isValid === false &&
                        <div>
                            {getInvalidDetails("Domain Verification Details", validationResult.domainVerificationValidationResult,
                                `Add the following verification TXT record to the DNS for ${domain}`, validationResult.domainVerificationIntructions)}
                        </div>
                    }
                    {validationResult.dkimValidationResult.isValid === false &&
                        <div>
                            {getInvalidDetails("DKIM Details", validationResult.dkimValidationResult,
                                `Add the following CNAME record to the DNS for ${domain}`, validationResult.dkimIntructions)}
                        </div>
                    }
                    {validationResult.dmarcValidationResult.isValid === false &&
                        <div>
                            {getInvalidDetails("DMARC Details", validationResult.dmarcValidationResult,
                                `A neutral policy (p=none) which wont affect other emails sent with this domain from other systems is recommended to start with. Add the following TXT record to the DNS for ${domain}`,
                                validationResult.dmarcIntructions)}
                        </div>
                    }
                    {showReturnPathResult && validationResult.customReturnPathValidationResult.isValid === false &&
                        <div>
                            {getInvalidDetails("Return-path Details", validationResult.customReturnPathValidationResult,
                                `Add the following CNAME record to the DNS for ${domain}`, validationResult.customReturnPathIntructions)}
                        </div>
                    }
                    <br></br>
                </div> :
                <div>
                    <h1>Results</h1>
                    {getEmptyCallout("Domain Ownership Verification")}
                    <br></br>
                    {getEmptyCallout("DKIM Verification")}
                    <br></br>
                    {getEmptyCallout("DMARC Verification")}
                    {showReturnPathResult &&
                        <div>
                            <br></br>
                            {getEmptyCallout("Custom Return-path Verification")}
                        </div>
                    }
                </div>
            }
        </div>
    );
}

function getInvalidDetails(header: string, settingResult: DeliverabilitySettingValidationResult, instructionHeader: string, instruction: string) {
    return <div>
        <h2>{header}</h2>
        <div>{settingResult.errorMessage}</div>
        {instruction &&
            <div>
                <br></br>
                <div style={{ marginBottom: "10px" }}>{instructionHeader}</div>
                <code className="instructions">{instruction}</code>
                <button className="icon-button copy" onClick={() => { navigator.clipboard.writeText(instruction) }}>
                    <LimelIcon name="copy" ></LimelIcon>
                </button>
            </div>
        }
        {settingResult.deliverabilitySettingErrorType === 1 && settingResult.foundValues.length > 0 &&
            <div>
                <h5>Found DNS values</h5>
                <code>
                    {settingResult.foundValues.map(date => `"${date}"\n`)}
                </code>
                <br></br>
            </div>
        }
    </div>
}

function getEmptyCallout(heading: string) {
    return <LimelCallout style={{ maxWidth: "400px" }} icon="" heading={heading} type="note">...</LimelCallout>
}

function getCallout(heading: string, invalidText: string, settingResult: DeliverabilitySettingValidationResult) {
    let icon, type, text = "";
    if (settingResult.isValid) {
        icon = "checked";
        type = "tip";
        text = "Valid";
    } else {
        icon = "error";
        type = "warning";
        text = invalidText;
    }
    return <LimelCallout style={{ maxWidth: "400px" }}
        icon={icon}
        heading={heading}
        type={type}>{text}</LimelCallout>
}

//import React, { FC } from 'react';

//interface MessageProps {
//    message: string;
//    user?: string
//}


//function FunctionalComponent({ message, user = "loggeduser" }: MessageProps) {
//    return (
//        <>
//            <h1>Welcome {message} - {user}</h1>
//        </>
//    );
//};

//export default FunctionalComponent;
